import React from 'react';
import {
  Grid,
  TextField,
  Autocomplete
} from '@mui/material';
import { getImageFieldsConfig } from '../constants/aiModels';
import ImageFieldsSection from './ImageFieldsSection';

function AgentFormModelSettings({
  providerAi,
  modelAi,
  temperature,
  maxTokens,
  topP,
  errors,
  availableModels,
  aiProviders,
  onFieldChange,
  onAutocompleteChange,
  imageDimension,
  aspectRatio,
  imageSize,
  agentId,
  isImageAgent
}) {
  const imageFieldsConfig = getImageFieldsConfig(agentId, providerAi);

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Autocomplete
          freeSolo
          options={aiProviders.map(p => p.name)}
          value={providerAi}
          onChange={(e, newValue) => onAutocompleteChange(newValue, 'providerAi')}
          onInputChange={(e, newInputValue, reason) => {
            if (reason === 'input') {
              onAutocompleteChange(newInputValue, 'providerAi');
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Proveedor AI"
              required
              error={!!errors.providerAi}
              helperText={errors.providerAi || "Selecciona de la lista o escribe uno personalizado"}
            />
          )}
        />
      </Grid>
      <Grid item xs={6}>
        <Autocomplete
          freeSolo
          options={availableModels}
          value={modelAi}
          onChange={(e, newValue) => onAutocompleteChange(newValue, 'modelAi')}
          onInputChange={(e, newInputValue, reason) => {
            if (reason === 'input') {
              onAutocompleteChange(newInputValue, 'modelAi');
            }
          }}
          disabled={!providerAi}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Modelo AI"
              required
              error={!!errors.modelAi}
              helperText={
                errors.modelAi || (
                  providerAi
                    ? (isImageAgent
                        ? "Modelos de imagen para " + providerAi + " (o escribe uno personalizado)"
                        : "Modelos de texto para " + providerAi + " (o escribe uno personalizado)"
                      )
                    : "Selecciona un proveedor primero"
                )
              }
            />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label="Temperature"
          type="number"
          inputProps={{ step: 0.1, min: 0, max: 1 }}
          fullWidth
          value={temperature}
          onChange={(e) => onFieldChange(parseFloat(e.target.value) || 0, 'temperature')}
          helperText="(0-1, defecto: 0.7)"
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label="Max Tokens"
          type="number"
          fullWidth
          value={maxTokens}
          onChange={(e) => onFieldChange(parseInt(e.target.value, 10) || 0, 'maxTokens')}
          helperText="(defecto: 150)"
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label="Top P"
          type="number"
          inputProps={{ step: 0.1, min: 0, max: 1 }}
          fullWidth
          value={topP}
          onChange={(e) => onFieldChange(parseFloat(e.target.value) || 0, 'topP')}
          helperText="(0-1, defecto: 0.9)"
        />
      </Grid>
      {imageFieldsConfig.showFields && (
        <ImageFieldsSection
          provider={imageFieldsConfig.provider}
          providerAi={providerAi}
          onAutocompleteChange={onAutocompleteChange}
          imageDimension={imageDimension}
          aspectRatio={aspectRatio}
          imageSize={imageSize}
          errors={errors}
        />
      )}
    </Grid>
  );
}

export default AgentFormModelSettings;
